import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

const flightDataUploadStepSchema = z.enum(['component', 'config', 'upload'])
const flightDataUploadFlightSetSchema = z.enum([
  'day-rgb',
  'day-ir',
  'night-ir',
])

export type FlightDataUploadPageSearchParams = {
  step: z.infer<typeof flightDataUploadStepSchema> | undefined
  asset: string | undefined
  component: string | undefined
  flightSet: z.infer<typeof flightDataUploadFlightSetSchema> | undefined
  weather: string | undefined
}

export const flightDataUploadPageSearchParamsSchema = z.object({
  step: flightDataUploadStepSchema.optional(),
  asset: z.string().optional(),
  component: z.string().optional(),
  flightSet: flightDataUploadFlightSetSchema.optional(),
  weather: z.string().optional(),
})

export const flightDataUploadSearchParamsSchema =
  flightDataUploadPageSearchParamsSchema.extend({
    [SEARCH_PARAM_SITE_ID]: z.string(),
  })
